import { toast } from 'vue3-toastify';
const initialState = () => ({
    newEntities: [
        // {
        //     menu: null,
        //     timelineId: null,
        //     timelineHeadLine: null,
        //     selectedDate: new Date(),
        //     replyTo: [],
        //     subject: null,
        //     replyToEmailId: null,
        //     contentHtml: '',
        //     eventData: null,
        // }
    ],
    timelines: [],
    activeEntityId: null,
});
export const state = initialState();
export const getters = {
    floatTimelines: state =>
        state.timelines
            .filter(t => t.isFloat === true),
    getTimelineEntities: state => (id, openIn = null) => {
        const timeline = state.timelines.find(t => t.id === id);
        if (!timeline) return [];
        if (openIn) {
            return timeline.entities.filter(e => e.openIn === openIn);
        }
        return timeline.entities;
    },
    getEntityOpenIn: state => (timelineId, entityId) => {
        const timeline = state.timelines.find(t => t.id === timelineId);
        if (!timeline) return null;
        const entity = timeline.entities.find(e => e.id === entityId);
        return entity?.openIn || null;
    }
}
export const actions = {
    addForm({ commit, rootGetters, state }, { timelineId, headLine, menu, openIn, isNewEmail = false, initialData = null, contentHtml = '', replyTo = null, replyToEmailId = null, subject = null, isForward = false }) {
        const result = calculateTimelinesCount(state, rootGetters, timelineId);
        const userEmail = rootGetters['user/user']?.email?.toLowerCase() || null;

        const resolveReplyData = (timelineSource) => {
            if (isNewEmail) return { replyToAddresses: [], resolvedSubject: null, resolvedReplyToEmailId: null, resolvedGmailThreadId: null, resolvedInReplyTo: null, resolvedReferences: [] }
            // Use pre-computed values from the caller when available
            if (replyTo !== null) {
                const emailMessages = timelineSource?.emailMessages || []
                const lastEmail = emailMessages.length ? emailMessages[emailMessages.length - 1] : null
                const references = emailMessages.map(e => e.messageId).filter(Boolean)
                console.log(timelineSource)
                return {
                    replyToAddresses: replyTo,
                    resolvedSubject: subject,
                    resolvedReplyToEmailId: replyToEmailId,
                    resolvedGmailThreadId: lastEmail?.gMailThreadId,
                    resolvedInReplyTo: lastEmail?.messageId || null,
                    resolvedReferences: references
                }
            }
            // Fall back to store-side calculation
            const replyToAddresses = (menu === 'emails' && timelineSource)
                ? calculateReplyto(timelineSource, userEmail)
                : []
            const firstEmail = timelineSource?.emailMessages?.length
                ? timelineSource.emailMessages[0]
                : null
            const lastEmail = timelineSource?.emailMessages?.length
                ? timelineSource.emailMessages[timelineSource.emailMessages.length - 1]
                : null
            const emailMessages = timelineSource?.emailMessages || []
            const references = emailMessages.map(e => e.messageId).filter(Boolean)
            return {
                replyToAddresses,
                resolvedSubject: lastEmail?.subject || null,
                resolvedReplyToEmailId: lastEmail?.id || null,
                resolvedGmailThreadId: firstEmail?.gMailThreadId != null ? String(firstEmail.gMailThreadId) : null,
                resolvedInReplyTo: lastEmail?.messageId || null,
                resolvedReferences: references
            }
        }

        if (result.op === 'add') {
            const timelineSource = result.timeline[0];
            const { replyToAddresses, resolvedSubject, resolvedReplyToEmailId, resolvedGmailThreadId, resolvedInReplyTo, resolvedReferences } = resolveReplyData(timelineSource)
            const newEntity = {
                id: crypto.randomUUID(),
                menu: menu,
                timelineId: timelineId,
                timelineHeadLine: headLine,
                selectedDate: new Date(),
                replyTo: replyToAddresses,
                subject: resolvedSubject,
                replyToEmailId: resolvedReplyToEmailId,
                gmailThreadId: resolvedGmailThreadId,
                inReplyTo: resolvedInReplyTo,
                references: resolvedReferences,
                contentHtml: contentHtml,
                eventData: null,
                data: initialData,
                openIn: openIn,
                isForward: isForward,
            };
            const timelineToAdd = timelineSource
                ? { ...timelineSource, entities: [newEntity] }
                : { id: timelineId, entities: [newEntity] };
            commit('ADD_TIMELINE', timelineToAdd);
        }
        else if (result.op === 'update') {
            if (result.timeline[0].entities.length >= 5) {
                toast("Cant open more than 5 creation form", {
                    autoClose: 2000,
                    theme: 'email',
                });
                return;
            }
            const { replyToAddresses, resolvedSubject, resolvedReplyToEmailId, resolvedGmailThreadId, resolvedInReplyTo, resolvedReferences } = resolveReplyData(result.timeline[0])
            let entity = {
                id: crypto.randomUUID(),
                menu: menu,
                timelineId: timelineId,
                timelineHeadLine: headLine,
                selectedDate: new Date(),
                replyTo: replyToAddresses,
                subject: resolvedSubject,
                replyToEmailId: resolvedReplyToEmailId,
                gmailThreadId: resolvedGmailThreadId,
                inReplyTo: resolvedInReplyTo,
                references: resolvedReferences,
                contentHtml: contentHtml,
                eventData: null,
                zIndex: 1,
                data: initialData,
                isMinimized: true,
                openIn: openIn,
                isForward: isForward,
            }
            commit('UPDATE_TIMELINE', { entity: entity, timelineId: timelineId });
        }

    },
    toggleOpenIn({ commit }, { timelineId, entityId }) {
        commit('TOGGLE_OPEN_IN', { timelineId, entityId });
    },
    setOpenIn({ commit }, { timelineId, entityId, openIn }) {
        commit('SET_OPEN_IN', { timelineId, entityId, openIn });
    },
    toggleAllEntitiesOpenIn({ commit }, { timelineId, fromOpenIn }) {
        commit('TOGGLE_ALL_ENTITIES_OPEN_IN', { timelineId, fromOpenIn });
    },
    removeEntity({ commit }, request) {
        commit('REMOVE_ENTITY', request);
    },
    toggleMinimize({ commit }, request) {
        commit('TOGGLE_MINIMIZE', request);
    },
    saveData({ commit }, request) {
        commit('SAVE_DATA', request);
    },
    openEntity({ commit }, id) {
        commit('SET_ACTIVE_ENTITY', id);
    },
    openTimeline({ commit }, id) {
        commit('SET_ACTIVE_TIMELINE', id);
    },
    closeTimeline({ commit }, id) {
        commit('SET_DEACTIVE_TIMELINE', id);
    },
    removeTimeline({ commit }, id) {
        commit('REMOVE_TIMELINE', id);
    },
    unlink({ commit }, id) {
        commit('UNLINK', id);
    },
    expandTimeline({ commit }, id) {
        commit('EXPAND_TIMELINE', id);
    },
    mergeDrafts({ commit, rootGetters, state }) {

        const timelines = rootGetters['timeline/timelines']?.items || []
        const timelinesDrafts = rootGetters['draftEmail/draftTimelines']?.items || []
        const draftMessages = []
        timelinesDrafts.forEach(timeline => {
            (timeline.emailMessages || []).forEach(msg => {
                if (msg.mainFolder === 8) {
                    draftMessages.push(msg)
                }
            })
        })
        if (!timelinesDrafts.length || !timelines.length) return
        for (const draft of draftMessages) {
            if (!draft.gMailThreadId) continue
            const draftThreadId = String(draft.gMailThreadId)

            const timeline = timelines.find(t =>
                t.emailMessages?.some(m => m.gMailThreadId != null && String(m.gMailThreadId) === draftThreadId)
            )
            if (!timeline) continue

            const existingTimeline = state.timelines.find(t => t.id === timeline.id)
            const alreadyAttached = existingTimeline?.entities?.some(e =>
                e.draftMessageId === draft.messageId ||
                e.data?.email?.messageId === draft.messageId
            )
            if (alreadyAttached) continue

            const emailMessages = timeline.emailMessages || []
            const lastEmail = emailMessages.length ? emailMessages[emailMessages.length - 1] : null
            const references = emailMessages.map(e => e.messageId).filter(Boolean)
            const parseList = (str) => (str
                ? str.split(';').map(entry => {
                    const m = entry.trim().match(/(.*?)\s*<(.+?)>/)
                    return m ? { name: m[1], emailAddress: m[2] } : null
                }).filter(Boolean)
                : [])
            const toAddresses = parseList(draft.recipientsTo)
            const ccAddresses = parseList(draft.recipientsCc)
            const bccAddresses = parseList(draft.recipientsBcc)
            const attachments = (draft.attachments || []).map(att => ({
                ...att,
                isDraft: true,
                hasThumbnail: false,
                messageId: att.messageId || draft.messageId,
            }))
            const isImportant = Array.isArray(draft.labels)
                ? draft.labels.some(l => l?.label === 'Important')
                : false

            const newEntity = {
                id: crypto.randomUUID(),
                menu: 'emails',
                timelineId: timeline.id,
                timelineHeadLine: timeline.headLine,
                selectedDate: new Date(),
                replyTo: [],
                subject: null,
                replyToEmailId: lastEmail?.id || null,
                gmailThreadId: draftThreadId,
                inReplyTo: lastEmail?.messageId || null,
                references,
                contentHtml: '',
                eventData: null,
                data: {
                    email: {
                        provider: draft.provider,
                        userid: draft.userId,
                        uId: draft.uId,
                        timelineId: draft.timelineId,
                        messageId: draft.messageId,
                        gmailThreadId: draftThreadId,
                        inReplyTo: lastEmail?.messageId || null,
                        references,
                        subject: draft.subject || '',
                        body: draft.contentHtml || '',
                        attachments,
                        isImportant,
                        dueDate: null,
                        toAddresses,
                        ccAddresses,
                        bccAddresses,
                        fromAddress: {},
                    },
                    toAddresses,
                    ccAddresses,
                    bccAddresses,
                },
                openIn: 'inline',
                draftMessageId: draft.messageId,
            }

            if (existingTimeline) {
                commit('UPDATE_TIMELINE', { entity: newEntity, timelineId: timeline.id })
            } else {
                commit('ADD_TIMELINE', { ...timeline, entities: [newEntity] })
            }
        }

    },
    addDraftForm({ commit, state }, { timeline, draft }) {
        if (!timeline || !draft) return

        // For orphaned drafts (no meaningful contact/conversation), create a unique virtual timeline
        let timelineId = timeline.id
        let timelineToUse = timeline

        if (!timeline.headLine && (!timeline.emailMessages || timeline.emailMessages.filter(m => m.mainFolder !== 8).length === 0)) {
          // This is an orphaned/virtual timeline with only drafts
          // Create a unique virtual timeline for this draft
          timelineId = 'draft-' + draft.messageId
          timelineToUse = {
            ...timeline,
            id: timelineId,
            headLine: 'Unsent Draft'
          }
        }

        const existingTimeline = state.timelines.find(t => t.id === timelineId)
        const alreadyAttached = existingTimeline?.entities?.some(e =>
            e.draftMessageId === draft.messageId ||
            e.data?.email?.messageId === draft.messageId
        )
        if (alreadyAttached) return

        const emailMessages = (timelineToUse.emailMessages || []).filter(m => m.mainFolder !== 8)
        const lastEmail = emailMessages.length ? emailMessages[emailMessages.length - 1] : null
        const references = emailMessages.map(e => e.messageId).filter(Boolean)
        const parseList = (str) => (str
            ? str.split(';').map(entry => {
                const m = entry.trim().match(/(.*?)\s*<(.+?)>/)
                return m ? { name: m[1], emailAddress: m[2] } : null
            }).filter(Boolean)
            : [])
        const toAddresses = parseList(draft.recipientsTo)
        const ccAddresses = parseList(draft.recipientsCc)
        const bccAddresses = parseList(draft.recipientsBcc)
        const attachments = (draft.attachments || []).map(att => ({
            ...att,
            isDraft: true,
            hasThumbnail: false,
            messageId: att.messageId || draft.messageId,
        }))
        const isImportant = Array.isArray(draft.labels)
            ? draft.labels.some(l => l?.label === 'Important')
            : false
        const threadId = draft.gMailThreadId != null ? String(draft.gMailThreadId) : null

        const newEntity = {
            id: crypto.randomUUID(),
            menu: 'emails',
            timelineId: timelineId,
            timelineHeadLine: timelineToUse.headLine,
            selectedDate: new Date(),
            replyTo: [],
            subject: null,
            replyToEmailId: lastEmail?.id || null,
            gmailThreadId: threadId,
            inReplyTo: lastEmail?.messageId || null,
            references,
            contentHtml: '',
            eventData: null,
            data: {
                email: {
                    provider: draft.provider,
                    userid: draft.userId,
                    uId: draft.uId,
                    timelineId: draft.timelineId,
                    messageId: draft.messageId,
                    gmailThreadId: threadId,
                    inReplyTo: lastEmail?.messageId || null,
                    references,
                    subject: draft.subject || '',
                    body: draft.contentHtml || '',
                    attachments,
                    isImportant,
                    dueDate: null,
                    toAddresses,
                    ccAddresses,
                    bccAddresses,
                    fromAddress: {},
                },
                toAddresses,
                ccAddresses,
                bccAddresses,
            },
            openIn: 'inline',
            draftMessageId: draft.messageId,
        }

        if (existingTimeline) {
            commit('UPDATE_TIMELINE', { entity: newEntity, timelineId: timelineId })
        } else {
            commit('ADD_TIMELINE', { ...timelineToUse, id: timelineId, entities: [newEntity] })
        }
    },

}
// function calculateTimelinesCount(state, rootGetters, timelineId) {
//     const existingTimeline = state.timelines.find(timeline => timeline.id === timelineId);
//     if (existingTimeline) {
//         return ({ timeline: [existingTimeline], op: 'update', isFloat: true, isActive: false })
//     }
//     let nonfloat = state.timelines.filter(t => t.isFloat === true).length >= 2
//     const timeline = rootGetters['timeline/getTimelineById'](timelineId);
//     if (nonfloat) {
//         return ({ timeline: [timeline], op: 'add', isFloat: false, isActive: false })
//     }
//     else {
//         return ({ timeline: [timeline], op: 'add', isFloat: true, isActive: true })
//     }
// }
function calculateTimelinesCount(state, rootGetters, timelineId) {
    const existingTimeline = state.timelines.find(timeline => timeline.id === timelineId);
    if (existingTimeline) {
        return ({ timeline: [existingTimeline], op: 'update' })
    }
    else {
        const timeline = rootGetters['timeline/getTimelineById'](timelineId);
        return ({ timeline: [timeline], op: 'add' })
    }
}

// Resolves the timeline that owns an entity. A timelineId is used when the caller supplies
// one, otherwise every timeline is scanned (entity ids are uuids, so they are unique).
export function findTimelineOfEntity(state, entityId, timelineId = null) {
    if (timelineId != null) {
        const timeline = state.timelines.find(t => t.id === timelineId);
        return timeline?.entities?.some(e => e.id === entityId) ? timeline : null;
    }
    return state.timelines.find(t => t.entities?.some(e => e.id === entityId)) || null;
}

function calculateReplyto(timeline, userEmail) {
    console.log(timeline)
    const emailMessages = timeline?.emailMessages || []
    if (emailMessages.length === 0) return []

    const emailRegex = /<([^>]+)>/
    const lastEmail = emailMessages[emailMessages.length - 1]

    const senderMatch = lastEmail.senders?.match(emailRegex)
    const senderEmail = senderMatch ? senderMatch[1].toLowerCase() : null

    const emailAddresses = []

    if (senderEmail && senderEmail !== userEmail) {
        // Last email was received — reply to the sender
        emailAddresses.push(senderEmail)
    } else {
        // Last email was sent by us — reply to the recipients
        const recipients = lastEmail.recipientsTo ? lastEmail.recipientsTo.split(';') : []
        for (const recipient of recipients) {
            const match = recipient.match(emailRegex)
            if (match) {
                const recipientEmail = match[1].toLowerCase()
                if (recipientEmail !== userEmail && !emailAddresses.includes(recipientEmail)) {
                    emailAddresses.push(recipientEmail)
                }
            }
        }
    }

    const Participants = []
    emailAddresses.forEach((email) => {
        const participant = timeline.participants?.find(
            (participant) => participant.email === email
        )
        if (participant) {
            Participants.push({ id: participant.id, emailAddress: participant.email })
        } else {
            Participants.push({ emailAddress: email })
        }
    })
    return Participants
}
export const mutations = {
    TOGGLE_OPEN_IN(state, { timelineId, entityId }) {
        const timeline = state.timelines.find(t => t.id === timelineId);
        if (timeline) {
            const entity = timeline.entities.find(e => e.id === entityId);
            if (entity) {
                entity.openIn = entity.openIn === 'sidepanel' ? 'inline' : 'sidepanel';
            }
        }
    },
    SET_OPEN_IN(state, { timelineId, entityId, openIn }) {
        const timeline = state.timelines.find(t => t.id === timelineId);
        if (timeline) {
            const entity = timeline.entities.find(e => e.id === entityId);
            if (entity) {
                entity.openIn = openIn;
            }
        }
    },
    TOGGLE_ALL_ENTITIES_OPEN_IN(state, { timelineId, fromOpenIn }) {
        const timeline = state.timelines.find(t => t.id === timelineId);
        if (timeline) {
            const toOpenIn = fromOpenIn === 'sidepanel' ? 'inline' : 'sidepanel';
            timeline.entities.forEach(entity => {
                if (entity.openIn === fromOpenIn) {
                    entity.openIn = toOpenIn;
                }
            });
        }
    },
    UNLINK(state, request) {
        const timeline = state.timelines.find(t => t.id === request.timelineId);
        if (timeline) {
            const entity = timeline.entities.find(entity => entity.id === request.entityId);
            if (entity) {
                entity.timeline = null;
                entity.timelineHeadLine = null;
                entity.replyToEmailId = null;
                entity.replyTo = [];

            }
        }
    },
    ADD_TIMELINE(state, timeline) {
        state.timelines.push(timeline)
    },
    // ADD_TIMELINE(state, timeline) {
    //     if (timeline.isActive) {
    //         state.timelines.forEach(t => t.isActive = false);
    //     }
    //     else {
    //         state.timelines.forEach(t => t.isActive = false)
    //     }
    //     // timeline.isActive = true;
    //     if (state.timelines.length > 0) {
    //         state.timelines.unshift(timeline);

    //     } else {
    //         state.timelines.push(timeline)

    //     }
    // },
    UPDATE_TIMELINE(state, requst) {
        const timeline = state.timelines.find(t => t.id === requst.timelineId);
        if (timeline) {
            timeline.entities.push(requst.entity)
        }
    },
    // UPDATE_TIMELINE(state, requst) {
    //     const timeline = state.timelines.find(t => t.id === requst.timelineId);
    //     if (timeline) {
    //         timeline.entities.push(requst.entity)
    //         if (!timeline.isFloat) {
    //             return;
    //         }
    //         else {
    //             if (timeline.isFloat && timeline.isActive) {
    //                 return;
    //             }
    //             else if (timeline.isFloat && !timeline.isActive) {
    //                 const firstOne = state.timelines.find(t => t.isActive === true && t.isFloat === true)
    //                 firstOne.isActive = false
    //                 timeline.isActive = true

    //             }
    //         }

    //     }
    // },
    REMOVE_ENTITY(state, request) {
        const timeline = state.timelines.find(t => t.id === request.timelineId);
        if (timeline) {
            // Find the index of the entity being removed
            const index = timeline.entities.findIndex(entity => entity.id === request.entityId);

            // Remove the entity
            timeline.entities = timeline.entities.filter(entity => entity.id !== request.entityId);
            if (timeline.entities == 0) {
                timeline.isFloat = false;
            }

            // Set isMinimized = false for the next entity, or the first one if no next entity exists
            if (timeline.entities.length > 0) {
                const nextEntity = timeline.entities[index] || timeline.entities[0];
                nextEntity.isMinimized = false;
            }
        }
    },
    SAVE_DATA(state, request) {
        const timeline = state.timelines.find(t => t.id === request.timelineId);
        if (timeline) {
            const entity = timeline.entities.find(entity => entity.id === request.entityId);
            if (entity) {
                entity.data = request.data
            }

        }
    },
    TOGGLE_MINIMIZE(state, request) {
        // Live callers (EventForm, TaskForm, ContactForm, EmailForm, EventDetail) only send
        // { entityId, data } - no timelineId - so the owning timeline is resolved by lookup.
        const timeline = findTimelineOfEntity(state, request.entityId, request.timelineId);
        if (!timeline) return;
        const entity = timeline.entities.find(e => e.id === request.entityId);
        if (!entity) return;

        entity.isMinimized = !entity.isMinimized;

        // If minimized, remove as active; if maximized, set as active
        state.activeEntityId = entity.isMinimized ? null : entity.id;

        if (request.data) {
            entity.data = request.data;
        }

        // The old flat model re-stacked every open form when they were all minimized.
        // The nested equivalent is scoped to the owning timeline: once all of its entities
        // are minimized their zIndexes are re-stacked in array order.
        if (timeline.entities.every(e => e.isMinimized)) {
            timeline.entities.forEach((e, index) => {
                e.zIndex = index + 1;
            });
        }
    },
    SET_ACTIVE_ENTITY(state, request) {
        const timeline = state.timelines.find(t => t.id === request.timelineId);
        if (timeline) {
            const totalEntities = timeline.entities.length;
            const activeEntityIndex = timeline.entities.findIndex(entity => entity.id === request.entityId);
            timeline.entities.forEach((entity, index) => {
                if (entity.id === request.entityId) {
                    // Set the zIndex for the selected entity to the highest value (based on the total count)
                    entity.zIndex = totalEntities * 10;  // Max zIndex = 10 * totalEntities
                    entity.isMinimized = false; // Ensure the selected entity is not minimized
                } else {
                    // Entities before the selected one will have lower zIndexes
                    if (index < activeEntityIndex) {
                        entity.zIndex = (totalEntities - index - 1) * 10;
                    } else {
                        // Entities after the selected one will have zIndexes reduced from max downwards
                        entity.zIndex = (totalEntities - index) * 10;
                    }
                    entity.isMinimized = true; // Minimize all other entities
                }
            });
        }
    },
    SET_ACTIVE_TIMELINE(state, timelineId) {
        const timeline = state.timelines.find(t => t.id === timelineId);
        if (timeline.isFloat && timeline.isActive) {
            return;
        }
        if (timeline.isFloat && !timeline.isActive) {
            const floatingTimelines = state.timelines.filter(t => t.isFloat === true)
            const secoundTimeline = floatingTimelines.find(t => t.id !== timelineId)
            if (secoundTimeline) {
                secoundTimeline.isActive = false;
            }
            timeline.isActive = true;
            return;
        }
        if (timeline.isFloat === false) {
            const floatingTimelines = state.timelines.filter(t => t.isFloat === true)
            if (!floatingTimelines.length > 0) {
                timeline.isActive = true;
                timeline.isFloat = true;
                return;

            }
            if (floatingTimelines.length === 2) {
                floatingTimelines[1].isFloat = false;
                floatingTimelines[0].isActive = false;
            }
            if (floatingTimelines.length === 1) {
                floatingTimelines[0].isActive = false;

            }
            timeline.isActive = true;
            timeline.isFloat = true;



        }

    },
    SET_DEACTIVE_TIMELINE(state, id) {
        const timeline = state.timelines.find(t => t.id === id);
        if (timeline) {
            timeline.isActive = false;
        }
    },
    EXPAND_TIMELINE(state, id) {
        const timeline = state.timelines.find(t => t.id === id);
        if (timeline) {
            timeline.isFloat = false;
            timeline.isActive = false;
        }
    },
    REMOVE_TIMELINE(state, id) {
        const index = state.timelines.findIndex(t => t.id === id);
        if (index !== -1) {
            state.timelines.splice(index, 1);
        }
    }
}
// requestData: {
//     page: 1,
//     pageSize: 50,
//     order: 1,
//     search: '',
//     archived: false,
//     deleted: false,
//     important: false,
//     waitingOn: false,
//     overdue: false,
//     folder: null,
//   },